import PocketBase from 'pocketbase';
import { env } from '@config/environment';
import type { TypedPocketBase } from './pocketbase-types';

// Initialize PocketBase client
const pbInstance = new PocketBase(env.pocketbaseUrl);
export const pb = pbInstance as TypedPocketBase;

// Set request timeout and logging slow requests (> 1s)
if ('httpClient' in pbInstance && pbInstance.httpClient) {
  const httpClient = pbInstance.httpClient as {
    timeout?: number;
    send: (url: string, config?: RequestInit) => Promise<Response>;
  };

  // Set request timeout (10 seconds)
  if (typeof httpClient.timeout !== 'undefined') {
    httpClient.timeout = 10000;
  }

  // Logging slow requests
  let requestStartTime = 0;
  const originalSend = httpClient.send.bind(httpClient);

  httpClient.send = async function (url: string, config?: RequestInit) {
    requestStartTime = performance.now();
    try {
      const response = await originalSend(url, config);
      const duration = performance.now() - requestStartTime;
      if (duration > 1000) {
        console.warn(`Slow request: ${url} took ${duration.toFixed(2)}ms`);
      }
      return response;
    } catch (error) {
      const duration = performance.now() - requestStartTime;
      if (duration > 1000) {
        console.warn(`Slow request (failed): ${url} took ${duration.toFixed(2)}ms`);
      }
      throw error;
    }
  };
}

// Auto-refresh auth token
pb.authStore.onChange((_token, model) => {
  if (model) {
    // Store auth in localStorage
    const authData = {
      token: pb.authStore.token,
      model: pb.authStore.model,
    };
    localStorage.setItem('pocketbase_auth', JSON.stringify(authData));
  } else {
    localStorage.removeItem('pocketbase_auth');
  }
});

// Restore auth from localStorage
try {
  const stored = localStorage.getItem('pocketbase_auth');
  if (stored) {
    const authData = JSON.parse(stored);
    if (authData.token && authData.model) {
      pb.authStore.save(authData.token, authData.model);
    }
  }
} catch (error) {
  console.error('Failed to restore auth:', error);
  localStorage.removeItem('pocketbase_auth');
}

export default pb;

